import emailjs from "@emailjs/browser";
import { getPlanById } from "../config/subscriptionPlans";

function getEmailJsConfig() {
    return {
        serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || "",
        templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "",
        publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "",
        adminEmail: process.env.REACT_APP_SYSTEM_ADMIN_EMAIL || "",
    };
}

/**
 * Notify the platform system administrator that a new school registered
 * and needs verification before the free trial starts.
 */
export async function notifySystemAdminOfSchoolRegistration(registration) {
    const { serviceId, templateId, publicKey, adminEmail } = getEmailJsConfig();

    if (!serviceId || !templateId || !publicKey || !adminEmail) {
        console.warn("EmailJS school verification notification skipped: missing env configuration.");
        return { ok: false, skipped: true };
    }

    const plan = getPlanById(registration?.subscriptionPlan);
    const reviewUrl = `${window.location.origin}/System/schools`;

    const templateParams = {
        to_email: adminEmail,
        admin_email: adminEmail,
        school_name: registration?.schoolName || "",
        director_name: registration?.name || "",
        director_email: registration?.email || "",
        school_type: registration?.schoolType || "",
        subscription_plan: plan.name,
        review_url: reviewUrl,
        message: `New school registration: ${registration?.schoolName || "Unknown school"} (${registration?.email || "no email"}) is awaiting verification.`,
    };

    await emailjs.send(serviceId, templateId, templateParams, { publicKey });
    return { ok: true };
}
